export const hex2Rgba = (hex: string, opacity: string = '0.2') => {
  if (hex.slice(0, 1) === '#') hex = hex.slice(1)
  if (hex.length === 3)
    hex =
      hex.slice(0, 1) +
      hex.slice(0, 1) +
      hex.slice(1, 2) +
      hex.slice(1, 2) +
      hex.slice(2, 3) +
      hex.slice(2, 3)

  let rgba = 'rgba('

  rgba += parseInt(hex.slice(0, 2), 16).toString() + ', '
  rgba += parseInt(hex.slice(2, 4), 16).toString() + ', '
  rgba += parseInt(hex.slice(4, 6), 16).toString() + ', '

  rgba += opacity + ')'

  return rgba
}
